import { AntTooltip, defaultTheme, Text } from '@agro-club/agroclub-shared'
import useFormatDate from 'hooks/useFormatDate'
import { DASH } from 'modules/constants'
import { User } from 'modules/domain/user/types'
import { FC } from 'react'
import styled from 'styled-components'
import { TruncatedValueWrapper } from '../TruncatedValue/TruncatedValue'

const CommentWrapper = styled.div`
  max-width: 400px;
`
const DateText = styled(Text)`
  color: ${defaultTheme.color.secondary200};
`
const CommentText = styled(Text)`
  white-space: pre-line;
  word-break: break-word;
`
const StyledTooltip = styled(AntTooltip)`
  cursor: pointer;
`

export const LastCommentCell: FC<{ user: User }> = ({ user }) => {
  const formatDate = useFormatDate()

  if (!user.comments.length) return <>{DASH}</>

  const tooltipContent = (
    <CommentWrapper>
      <DateText typography="bodySmall">{formatDate(user.comments[0].modified, { withTime: true })}</DateText>
      <CommentText typography="bodyMedium">{user.comments[0].comment}</CommentText>
    </CommentWrapper>
  )

  return (
    <StyledTooltip tooltipContent={tooltipContent} variant="secondary" placement="bottom">
      <Text color="secondary" typography="bodySmall">
        {formatDate(user.comments[0].modified, { withTime: true })}
      </Text>
      <TruncatedValueWrapper>{user.comments[0].comment}</TruncatedValueWrapper>
    </StyledTooltip>
  )
}
